import React from 'react';
import { siteConfig } from '../data';

export default function About() {
  return (
    <div className="animate-in fade-in duration-1000 pt-8 md:pt-12 pb-0">
      <div className="relative mb-24">
        <div className="max-w-5xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2">
            <div className="py-12 md:py-24 md:pr-12">
              <h1 className="text-4xl md:text-5xl font-serif text-slate-900 mb-8">Om Sandberg Rådgivende Ingeniører</h1>
              <div className="prose prose-slate prose-lg max-w-none">
                <p className="text-slate-600 leading-relaxed mb-6">
                  Sandberg, Rådgivende Ingeniører ApS er et rådgivende ingeniørfirma, hvor Henrik er eneste ansatte.
                </p>
                <p className="text-slate-600 leading-relaxed mb-6">
                  Henrik har en baggrund som tømrer fra det vestjyske, men valgte efter et par år som tømrersvend at læse videre til diplomingeniør på Horsens Teknikum. Har arbejdet i rådgiverbranchen i 28 år.
                </p>
                <p className="text-slate-600 leading-relaxed mb-6">
                  Mit speciale er bærende konstruktioner, men jeg har gennem årene oparbejdet erfaring i energiberegninger, projektering og tilsyn med kloakinstallationer og anlægsarbejder.
                </p>
                <p className="text-slate-600 leading-relaxed mb-6">
                  Har også erfaring med byggeledelse og tilsyn, og sætter stor pris på at komme ud på byggepladsen til håndværkerne.
                </p>
                <p className="text-slate-600 leading-relaxed mb-6">
                  Firmaets politik er levere et produkt, som til fulde lever op til det aftalte, både ydelsesmæssigt, men også tidsmæssigt.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="md:absolute md:top-0 md:right-0 md:bottom-0 md:w-1/2 h-[400px] md:h-auto">
          <img 
            src="https://assets.auxodev.dk/assets/5884feb0-c9b0-49c8-92cc-fcf945ff05d8/ragelund-efterskole-01.jpg" 
            alt="Rågelund Efterskole - Sandberg Rådgivende Ingeniører" 
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 py-16 border-t border-slate-100">
          <div>
            <h3 className="text-xl font-serif text-slate-900 mb-4">Vores Vision</h3>
            <p className="text-slate-500 text-sm leading-relaxed">
              At være den foretrukne samarbejdspartner for bygherrer, der ønsker uvildig rådgivning af højeste faglige kvalitet.
            </p>
          </div>
          <div>
            <h3 className="text-xl font-serif text-slate-900 mb-4">Vores Værdier</h3>
            <p className="text-slate-500 text-sm leading-relaxed">
              Ordentlighed, faglig stolthed og gennemsigtighed er kernen i alt, hvad vi gør. Vi holder, hvad vi lover, og leverer løsninger, der skaber reel værdi.
            </p>
          </div>
          <div>
            <h3 className="text-xl font-serif text-slate-900 mb-4">Vores Tilgang</h3>
            <p className="text-slate-500 text-sm leading-relaxed">
              Vi kombinerer klassiske ingeniørdyder med moderne metoder for at sikre, at projekterne gennemføres effektivt og fejlfrit.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
